
class PartiallyHiddenList {

    constructor(element, options={}) {
        if (!element) {
            console.error('container not found')
            return {}
        }
        const optionsDefault = {
            countVisible: 4,
            step: 2,
            hidingClass: 'hide',
            filterChildrenClass: ''
        }
        this.options = {...optionsDefault, ...options}
        this.element = element
        this.lastShowIndex = -1
        this.init()
    }

    init() {
        this.lastShowIndex = -1
        let children = Array.from(this.element.children)
        if (this.options.filterChildrenClass) {
            children = children.filter(child => child.classList.contains('this.options.filterChildrenClass'))
        }

        this.items = Array.from(this.element.children).map((children, index) => {
            let isShow = !children.classList.contains( this.options.hidingClass )
            if (isShow && this.lastShowIndex + 1 >= this.options.countVisible) {
                isShow = false
                children.classList.add( this.options.hidingClass )
            } else {
                children.classList.remove( this.options.hidingClass )
                this.lastShowIndex = index
            }
            const item = {
                index,
                element: children,
                isShow
            }

            return item
        })
    }

    showNext() {        
        let i = this.options.step
        while (i > 0) {
            const nextIndex = this.lastShowIndex + 1
            if ( !this.items[nextIndex] ) {
                return false
            }
            
            this.items[nextIndex].isShow = true
            this.items[nextIndex].element.classList.remove( this.options.hidingClass )
            this.lastShowIndex = nextIndex
            i -= 1
        }

        return true
    }
}

export default PartiallyHiddenList